import { render, staticRenderFns } from "./MatterDetails.vue?vue&type=template&id=1514e08d&scoped=true"
import script from "./MatterDetails.vue?vue&type=script&lang=js"
export * from "./MatterDetails.vue?vue&type=script&lang=js"
import style0 from "./MatterDetails.vue?vue&type=style&index=0&id=1514e08d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1514e08d",
  null
  
)

export default component.exports